import { QRCode } from '@progress/kendo-react-barcodes';
import { PDFExport } from '@progress/kendo-react-pdf';
import React from 'react';

export interface QRTaskPDFExportProps {
  pdfExportRef: React.RefObject<PDFExport | null>;
  fileName: string;
  logoUrl?: string;
  task: {
    title: string;
    qrValue: string;
  }[];
  gameTitle: string;
}

export const QRTaskPDFExport: React.FC<QRTaskPDFExportProps> = ({
  logoUrl,
  fileName,
  task,
  gameTitle,
  pdfExportRef
}) => {
  return (
    <div style={{ position: 'absolute', top: '-99999px', left: '-99999px' }}>
      <PDFExport
        ref={pdfExportRef}
        fileName={`${fileName}.pdf`}
        paperSize={'A4'}
        margin={0}>
        {task.map((t, idx) => (
          <div
            key={idx}
            className={'page-break'}
            style={{
              display: 'flex',
              //A4 width and height in pixel
              width: 595,
              height: 842,
              padding: '40px 48px',
              position: 'relative',
              alignItems: 'center',
              boxSizing: 'border-box',
              justifyContent: 'center',
              backgroundColor: '#ffffff'
            }}>
            <div
              style={{
                display: 'flex',
                textAlign: 'center',
                alignItems: 'center',
                flexDirection: 'column'
              }}>
              {logoUrl && (
                <img
                  src={logoUrl}
                  alt="Event logo"
                  style={{
                    width: 56,
                    height: 56,
                    marginBottom: 14,
                    objectFit: 'cover',
                    borderRadius: '50%'
                  }}
                />
              )}

              <div
                style={{
                  fontSize: 21,
                  fontWeight: 700,
                  marginBottom: 6,
                  letterSpacing: 0.5,
                  textTransform: 'uppercase'
                }}>
                {t.title}
              </div>

              <div
                style={{
                  fontSize: 12,
                  color: '#5c6b73',
                  marginBottom: 28
                }}>
                Scan the code to open the task
              </div>

              <div
                style={{
                  marginBottom: 24
                }}>
                <QRCode
                  size={270}
                  value={`${t.qrValue}`}
                  errorCorrection={'M'}
                />
              </div>

              <div
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: '#14BF8B'
                }}>
                {gameTitle}
              </div>
            </div>

            <div
              style={{
                left: 48,
                bottom: 36,
                display: 'flex',
                alignItems: 'center',
                position: 'absolute'
              }}>
              <img
                src="/cg-logo-stacked.svg"
                style={{
                  width: '50px',
                  height: 'auto'
                }}
              />
            </div>

            {task.length > 1 && (
              <div
                style={{
                  position: 'absolute',
                  right: 48,
                  bottom: 36,
                  fontSize: 11,
                  color: '#b3b3b3'
                }}>
                {idx + 1} of {task.length}
              </div>
            )}
          </div>
        ))}
      </PDFExport>
    </div>
  );
};
